import React from "react";
/**
 * Render the container for the weeks in the month grid.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Weeks(props) {
    return React.createElement("tbody", { ...props });
}
